var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M11 0v30","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M20 21l-9 9-9-9","key":1})]));
}

DownArrow.defaultProps = {"viewBox":"0 0 22 32","width":"22","height":"32"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
